export const cleanUpWorkflowStep = ({ step, app, workflow }) => {
  const slug = app?.slug;

  const cleanStep = { ...step };

  // Remove stepNumber property from step if it has it
  if ('stepNumber' in cleanStep) {
    delete cleanStep.stepNumber;
  }

  if (app?.type === 'trigger' || app?.type === 'input' || step?.type === 'trigger' || step?.type === 'input' || ['iterate', 'wait', 'transform', 'ifElse', 'continue', 'break', 'folder', 'webhook', 'memory', 'flowControl', 'runWorkflow', 'httpRequest', 'groupResults'].includes(slug)) {
    return cleanStep;
  }

  if (slug === 'map') {
    const steps = workflow?.steps;
    const workflowStepIds = steps?.map((n) => n?.id);
    const argInputStepIds = cleanStep?.arguments?.inputStepIds || [];
    const filteredIds = argInputStepIds?.filter((id) => workflowStepIds.includes(id));
    cleanStep.arguments = cleanStep.arguments || {};
    cleanStep.arguments.inputStepIds = filteredIds;
    return cleanStep;
  }

  const isFunction = !!step?.functionId;
  const args = cleanStep.arguments || {};
  const action = app?.actions?.find((a) => a?.id === step?.actionId);
  const actionArgs = action?.arguments || [];
  const newArgs = {};

  for (const key in args) {
    const arg = args[key];

    if (arg?.custom === true || isFunction) {
      newArgs[key] = arg;
      continue;
    }
    const parsedKey = key.replaceAll(/\[\d+\]/g, '[]');
    const essentialKey = key.replaceAll(/\[\]/g, '');
    const actionArg = actionArgs?.find((n) => [parsedKey, essentialKey].includes(n.key));

    if (actionArg) {
      newArgs[key] = arg;
      continue;
    }

    console.log('Warning: omitting invalid argument:', key, 'arg', arg);
    console.log('all args:', args, typeof args);
    // console.log('action arg', actionArg);
    // console.log('parsed key', parsedKey);
  }

  cleanStep.arguments = newArgs;

  return cleanStep;
};
